<form [formGroup]="form">
  <app-input-group>
    <label appLabel>{{ 'dashboard.remove.failedautomation.label' | translate: { count: elements.length } }}</label>
    <label class="ec-radio-label">
      <input appInput type="radio" formControlName="response" [value]="UserResponse.Approved"> {{ 'dashboard.remove.failedautomation.approve' | translate }}
    </label>
    <label class="ec-radio-label">
      <input appInput type="radio" formControlName="response" [value]="UserResponse.Rejected"> {{ 'dashboard.remove.failedautomation.deny' | translate }}
    </label>
  </app-input-group>
</form>
